<template>
<div class="chapter">
<div class="inner_page">
<p class="c3" id="calibre_pb_3"> <br class="calibre2"/></p>
<p class="c">The Inertia of Glue</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c6">We prepare for what ever</p>
<p class="c6">may come our way</p>
<p class="c6">Hoping to survive just</p>
<p class="c6">one more day.</p>
<p class="c6"> <br class="calibre2"/></p>
<p class="c6">We buy, can, do, get, until there's</p>
<p class="c6">Room for no more</p>
<p class="c6">And when the stress goes up,</p>
<p class="c6">it's back to the store.</p>
<p class="c6"> <br class="calibre2"/></p>
<p class="c6">Swimming in glue -</p>
<p class="c6">Can't move onward, but don't dare stop.</p>
<p class="c6">Not going forward, but can't go back.</p>
<p class="c6">(what did I forget? what do I lack?)</p>
<p class="c6">Questions and doubts settle like a cool fog,</p>
<p class="c6">tightening the grip.</p>
<p class="c6"> <br class="calibre2"/></p>
<p class="c6">Where do we go from here?</p>
<p class="c6">What do we do now?</p>
<p class="c6">The inertia of glue.</p>
<p class="c6"> <br class="calibre2"/></p>
<p class="c6">You prep</p>
<p class="c6">You lay plans</p>
<p class="c6">Never knowing if they're the right plans</p>
<p class="c6">Because you want to never use them,</p>
<p class="c6">or do you?</p>
<p class="c6">We tell them...</p>
<p class="c6">I'm prepared to be wrong ~</p>
<p class="c6">Are you?</p>
<p class="c6"> <br class="calibre2"/></p>
<p class="c6">By Deborah D. Moore</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?47c8b9d2